import EmptyResult from 'components/others/EmptyResult';
import ReportByTaskSummaryTableRow from './ReportByTaskSummaryTableRow';
import type { TaskPayReportRowType } from '@econtractor/types';

interface ReportByTaskSummaryTableBodyProps {
    users: TaskPayReportRowType[];
}

const ReportByTaskSummaryTableBody = ({ users }: ReportByTaskSummaryTableBodyProps) => (
    <tbody>
        {users.map((user) => (
            <ReportByTaskSummaryTableRow key={user.userId} user={user} />
        ))}
        {!users.length ? (
            <tr>
                <td colSpan={3}>
                    <EmptyResult />
                </td>
            </tr>
        ) : null}
    </tbody>
);

export default ReportByTaskSummaryTableBody;
